
import { ORDER_FEEDBACK_RESOLVE_MUTATION } from '@marketplace/graphql/orders.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalOrderViewIssue',

    props: {
        issueData: {
            type: Object,
            default: null,
        },
    },
    computed: {
        reportedOnFormattedDate() {
            return this.$datetime.formatDateFullMonthWithTimeNoSeconds(
                this.issueData.createdAt
            )
        },
    },

    methods: {
        closeModal() {
            EventBus.$emit('modal-close', {})
        },
        formatQuantityString(quantity) {
            return `<sub>&times</sub>${parseInt(quantity)}`
        },
        async updateStatus(id) {
            await this.resolveOrderFeedback(id)
            window.location.reload()
        },
        async resolveOrderFeedback(id) {
            await this.$apollo.mutate({
                mutation: ORDER_FEEDBACK_RESOLVE_MUTATION,
                variables: {
                    id,
                },
            })
        },
    },
}
